import {NotFoundError} from '@hm/fundamental'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {ROUTES} from './routing/routes'

export const NotFoundPage: React.FC = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const navigateToStartPage = useCallback(() => navigate(ROUTES.path, {replace: true}), [navigate])

  return (
    <div className="flex flex-col">
      <NotFoundError
        title={t('suite.notFoundPage.title')}
        description={t('suite.notFoundPage.description')}
        data-cy="not_found_error"
        pageOpenText={t('suite.notFoundPage.openStartPage')}
        onPageOpen={navigateToStartPage}
      />
    </div>
  )
}
